module.exports = __webpack_public_path__ + "static/media/user-locks.94323110.png";